import { Component, OnInit, ViewChildren, AfterViewInit, OnDestroy, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { MatSort, Sort } from '@angular/material/sort';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Message } from 'src/app/core/class/message';
import { ServiceTypeService } from 'src/app/core/services/service-type.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Subject } from 'rxjs';
import { MatOption, MatSelect } from '@angular/material';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { CommonService } from 'src/app/core/services/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ResponsiveService } from '../../../../../../../core/services/responsive.service';
import {
  Document,
  DocumentKeyPair, PaginateKeyPair, SortKeyPair
} from "../../../document/search-document-sign/search-document-sign.component";
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-dialog-sync-document-group',
  templateUrl: './dialog-sync-document-group.component.html',
  styleUrls: ['./dialog-sync-document-group.component.scss']
})
export class DialogSyncDocumentGroupComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  totalServiceType: number;
  isReadySignEkyc: boolean;
  isReadySignEkycAdvanced: boolean;
  widthHeadCofig = '';
  quantityEkycInfo = {
    ekycQuantity: 0,
    advanceEkycQuantity: 0,
    isBoughtEkyc: true,
    isBoughtEkycAdvanced: true
  };
  checkAll: boolean;
  dataSelected: Map<any, Document> = new Map<any, Document>();

  displayedFirstColumns: string[] = [];
  firstColumnDefinitions = [
    { def: 'firstId', showMobile: true },
    { def: 'firstName', showMobile: true },
    { def: 'firstCode', showMobile: true },
    { def: 'firstNote', showMobile: false },
  ];

  displayedColumns: string[] = [];
  columnDefinitions = [
    { def: 'check', showMobile: true, show: true },
    { def: 'id', showMobile: true, show: true },
    { def: 'name', showMobile: true, show: true },
    { def: 'code', showMobile: true, show: true },
    { def: 'note', showMobile: false, show: true },
    { def: 'status_sync', showMobile: true, show: true },
  ];

  documents = new Documents();
  parentDocuments: Document[];
  childOldDataList: DocumentKeyPair = {};
  childPaginateList: PaginateKeyPair = {};
  childSortList: SortKeyPair = {};
  childIsExpanding: Array<string>;
  paginate: {
    currentPage: number;
    pageSize: number;
    totalRow: number;
    totalPage: number;
    totalPageArray: any;
    no: any;
  };
  tplModal: NzModalRef;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('contentEmptyTable', { static: false }) contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table

  checkNote: any;

  @BlockUI() blockUI: NgBlockUI;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;


  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogSyncDocumentGroupComponent>,
    public serviceTypeService: ServiceTypeService,
    public commonService: CommonService,
    private message: Message,
    private toastr: ToastrService,
    private responsiveService: ResponsiveService,
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onBtnCancelClick();
    });
  }

  ngOnInit() {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: [],
    };

    this.documents = {
      name: '',
      syncStatus: 'NOT_SYNCED'
    };

    this.onFilterData();
    this.checkConfigureDisplayed();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
          this.getDisplayedFirstColumns();
        }
      }
    );
  }
  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }
  getDisplayedFirstColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedFirstColumns = this.firstColumnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedFirstColumns = this.firstColumnDefinitions.map(cd => cd.def);
    }
  }


  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.show)
        .map(cd => cd.def);
    }
  }

  onColumnDefinitionsChange(configureDisplayed: any) {
    this.columnDefinitions.forEach(element => {
      if (configureDisplayed.data.includes(element.def)) {
        element.show = false;
      } else {
        element.show = true;
      }
    });
    this.widthHeadCofig = `${(configureDisplayed.count + 2) * 90}px`;
    this.getDisplayedColumns();
  }

  checkConfigureDisplayed() {
    if (localStorage.getItem('configureDisplayed')) {
      const configureDisplayed = JSON.parse(localStorage.getItem('configureDisplayed'));
      this.onColumnDefinitionsChange(configureDisplayed);
    }
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize
    };

    this.onFilterData();
  }

  onFilterData() {
    this.serviceTypeService.filterSyncServiceTypes(
      {
        ...this.documents,
        ...this.paginate,
        page: this.paginate.currentPage,
      }
    ).subscribe(result => {
      console.log('result onFilterData --', result);
      result.data.dataRow.forEach(async(row) => {
        if(row.syncStatus === 'SYNCED')
        row.syncStatusMessage = await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_synced');
        else if (row.syncStatus === 'NOT_SYNCED')
        row.syncStatusMessage =  await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_not_synced');

      });
      this.dataSource.data = result.data.dataRow;

      if (result.data.dataRow) {
        this.checkNote = result.data.dataRow.filter((data: any) => data && data.type == 2);
      }

      this.isReadySignEkyc = result.allowEkyc;
      this.isReadySignEkycAdvanced = result.allowAdvanceEkyc;
      this.totalServiceType = result.totalRow;
      this.paginate = {
        ...this.paginate,
        currentPage: result.data.currentPage,
        pageSize: result.data.pageSize,
        totalRow: result.data.totalRow,
        totalPage: Math.ceil(result.data.totalRow / result.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(result.data.totalRow / result.data.pageSize), 1),
        no: this.commonService.counter(result.data.pageSize, result.data.currentPage * result.data.pageSize + 1)
      };

      this.initParent(result);
      this.checkCheckAll();
    });
  }

  onClickBtnFilter() {
    this.onFilterData();
  }

  public onSelectionChange(element) {
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }
    this.checkCheckAll();
  }

  checkCheckAll() {
    let data = [...this.dataSource.data]
    for (let i = 0; i < data.length; i++) {
      const currentRow = data[i];
      if (!this.dataSelected.has(currentRow.id)) {
        this.checkAll = false;
        break;
      }
      if (i === data.length - 1) {
        this.checkAll = true;
      }
    }
  }

  public checkAllDocument() {
    this.dataSource.data.forEach(data => {
      data.checked = this.checkAll;
      this.dataSelected.set(data.id, data);
      if (!this.checkAll) {
        this.dataSelected.delete(data.id);
      }
    });
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDocuments = rs.data.dataRow;

    this.parentDocuments.forEach(parent => {
      parent['STT'] = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
    });
    this.countDataSelected()
    this.initDataSelected();
    this.dataSource.data = this.parentDocuments;
    this.childIsExpanding = []; // close all parent
  }

  countDataSelected() {
    const dataSelectedClone = this.dataSelected
    this.dataSelected = new Map<any, Document>()
    
    for (let i = 0; i < this.parentDocuments.length; i++) {
      if (dataSelectedClone.has(this.parentDocuments[i].id)) {        
        this.dataSelected.set(this.parentDocuments[i].id, this.parentDocuments[i])
      }
    }    
  }

  initDataSelected() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    for (let i = 0; i < this.parentDocuments.length; i++) {
      if (this.dataSelected.has(this.parentDocuments[i].id)) {
        this.parentDocuments[i].checked = true;
      } else {
        this.parentDocuments[i].checked = false;
      }
    }

    for (let i = 0; i < this.parentDocuments.length; i++) {
      if (!this.dataSelected.has(this.parentDocuments[i].id)) {
        this.checkAll = false;
        break;
      }
      if (i === this.parentDocuments.length - 1) {
        this.checkAll = true;
      }
    }
  }

  synchronizeSelectedRecords() {
    let arrIds = []
    this.dataSelected.forEach(e => {
      arrIds.push(e.id)
    })
    const dataSync = {
      ids: arrIds,
      type: null
    }
    this.synchronizeServiceAction(dataSync)
  }

  synchronizeAll() {
    const dataSync = {
      type: "ALL",
      filter: {
        ...this.documents,
        ...this.paginate,
      }
    }
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.sync_service_type'), this.paginate.totalRow)
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.synchronizeServiceAction(dataSync)
      }
      dialogRe.close();
    });
  }

  synchronizeServiceAction(data) {
    this.serviceTypeService.syncServiceTypes(data).subscribe(res => {
      // console.log(res);
      if (res && res.success) {
        this.toastr.success(this.commonService.format(
          this.message.getMessage('messages.sync_servie_type_success'), res.data.done, parseInt(res.data.done) + parseInt(res.data.failed)))
        setTimeout(() => {
          this.closeDialog(true)
        }, 500);
      } else {
        this.toastr.error(res.message)
        this.onFilterData();
      }
    })
  }

  onBtnCancelClick() {
    // const dialogRe = this.dialog.open(WarningComponent, {
    //   width: '350px',
    //   data: this.message.getMessage('messages.confirm_change_data')
    // });
    // dialogRe.afterClosed().subscribe(rs => {
    //   if (rs) {
    //     this.closeDialog()
    //   }
    //   dialogRe.close();
    // });
    this.closeDialog(false)
  }

  closeDialog(isChange: boolean) {
    this.dialogRef.close(isChange);
    this.dataSelected.clear()
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: [],
    };
    this.documents = {
      name: '',
      syncStatus: 'NOT_SYNCED'
    };
    this.dataSource = new MatTableDataSource();
  }

}

export class Documents {
  name: string;
  syncStatus: string;
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: any;
  no: any;
}
